import {
  HOME_PROJECT_CLONE_STATUS_BEGIN,
  HOME_PROJECT_CLONE_STATUS_SUCCESS,
  HOME_PROJECT_CLONE_STATUS_FAILURE,
  HOME_PROJECT_CLONE_STATUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';
export function projectCloneStatus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_PROJECT_CLONE_STATUS_BEGIN,
    });
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/clone/status`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_PROJECT_CLONE_STATUS_SUCCESS,
            data: res,
          });
          resolve(res.data);
        },

        (err) => {
          dispatch({
            type: HOME_PROJECT_CLONE_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>projectCloneStatus', err);
        },
      );
    });

    return promise;
  };
}

export function dismissProjectCloneStatusError() {
  return {
    type: HOME_PROJECT_CLONE_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_PROJECT_CLONE_STATUS_BEGIN:
      return {
        ...state,
        projectCloneStatusPending: true,
        projectCloneStatusError: null,
      };

    case HOME_PROJECT_CLONE_STATUS_SUCCESS:
      return {
        ...state,
        projectCloneStatusPending: false,
        projectCloneStatusError: null,
        projectCloneStatus: action.data.data,
      };

    case HOME_PROJECT_CLONE_STATUS_FAILURE:
      return {
        ...state,
        projectCloneStatusPending: false,
        projectCloneStatusError: action.data.error,
      };

    case HOME_PROJECT_CLONE_STATUS_DISMISS_ERROR:
      return {
        ...state,
        projectCloneStatusError: null,
      };

    default:
      return state;
  }
}
